import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n'
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import '@fortawesome/fontawesome-free/css/all.min.css'
import 'react-toastify/dist/ReactToastify.css';

import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import "./sass/main.scss";


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  // </React.StrictMode>
);

